import React from 'react'

const Home = () => {
  return (
    <div className='center page'><div>Asset Managment</div></div>
  )
}

export default Home